// extracted by mini-css-extract-plugin
module.exports = {"article":"ArticlePreview_article__5ezrJ","article__meta":"ArticlePreview_article__meta__BTXW_","wrapper":"ArticlePreview_wrapper__XEKE4"};